import { Api } from 'models/services/api';
import { ReadSuppliersQuery } from 'models/services/graphql';

import { SupplierCollectionData } from '../collection';

type DataToRead = {
  businessId: string;
  nextToken?: string;
};

const RequestQuery = `
  query ReadSuppliers($businessId: ID!, $nextToken: String) {
    ${ReadSuppliersQuery}
  }
`;

type ResponseData = {
  data: {
    readSuppliers: SupplierCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: SupplierCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readSuppliers;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };